/**
 * Use Case: Deletar Estágio do Funil
 * Orquestra a exclusão de um estágio do funil
 */

import { IFunnelStageRepository } from '../../../domain/repositories/IFunnelStageRepository';
import { ILeadRepository } from '../../../domain/repositories/ILeadRepository';
import { NotFoundError, BusinessRuleError } from '../../../core/errors/DomainErrors';

export class DeleteFunnelStageUseCase {
    constructor(
        private readonly funnelStageRepository: IFunnelStageRepository,
        private readonly leadRepository: ILeadRepository
    ) { }

    async execute(stageId: string): Promise<void> {
        // Busca o estágio
        const stage = await this.funnelStageRepository.findById(stageId);

        if (!stage) {
            throw new NotFoundError('Estágio do funil', stageId);
        }

        // Valida se há leads neste estágio
        const leadsInStage = await this.leadRepository.findByStage(stageId);

        if (leadsInStage.length > 0) {
            throw new BusinessRuleError(
                `Não é possível deletar o estágio "${stage.getName()}" pois existem ${leadsInStage.length} negociação(ões) nele. ` +
                'Mova as negociações para outro estágio antes de deletar.'
            );
        }

        // Executa a exclusão
        await this.funnelStageRepository.delete(stageId);
    }
}
